export const abbreviateNumber = (number: number): string => {
  if (number < 1000) return number.toString();
  if (number < 1000000) return `${Math.round(number / 1000)}k`;
  return `${Math.round(number / 10000) / 100}M`;
};

export const clamp = (min: number, subject: number, max: number): number => Math.min(Math.max(min, subject), max);
